const COOKIE_CONSENT_KEY = 'cookie-consent';
const DATAFAST_SCRIPT_ID = 'datafast-script';
const DATAFAST_WEBSITE_ID = 'dfid_5wiNlRTX3FUcaZrFWFm7m';

const DATAFAST_ALLOWED_HOSTNAMES = [
  'memoriseit.com',
  'www.memoriseit.com',
  'memorise-it.lovable.app',
  'id-preview--a3478db7-7694-4a74-a1ba-d02bba93e8c1.lovable.app',
].join(',');

export const initDataFast = (): void => {
  if (typeof window === 'undefined') return;
  if (localStorage.getItem(COOKIE_CONSENT_KEY) !== 'accepted') return;
  if (document.getElementById(DATAFAST_SCRIPT_ID)) return;

  const domain = window.location.hostname.replace(/^www\./, '');

  const script = document.createElement('script');
  script.id = DATAFAST_SCRIPT_ID;
  script.defer = true;
  script.src = 'https://datafa.st/js/script.js';
  script.setAttribute('data-website-id', DATAFAST_WEBSITE_ID);
  script.setAttribute('data-domain', domain);
  script.setAttribute('data-allowed-hostnames', DATAFAST_ALLOWED_HOSTNAMES);

  document.head.appendChild(script);
};
